var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-c-item"},[_c('span',{staticClass:"title",style:({width: _vm.size+'px'})},[_vm._v(_vm._s(_vm.lableLeft))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.lableRight))])])}
var staticRenderFns = []

export { render, staticRenderFns }